var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"h-10 w-full object-contain",attrs:{"src":require("@/assets/icons/loader.gif")}})])
}]

export { render, staticRenderFns }